const PRIVACY_BASE_URL = 'https://playrix.com/privacy/index_:locale.html';
const TERMS_BASE_URL = 'https://playrix.com/terms/index_:locale.html';

const HELPSHIFT_BASE_URLS: Record<string, string> = {
  homescapes: 'https://playrix.helpshift.com/webchat/a/homescapes',
  township: 'https://playrix.helpshift.com/webchat/a/township',
};

export { PRIVACY_BASE_URL, TERMS_BASE_URL, HELPSHIFT_BASE_URLS };
